// Extend the String prototype
import {ITimeSpan, TimeSpan} from "./time-span";

String.prototype.toTimeSpanType = function (): ITimeSpan {
  const timeSpan = this as string;

  const isDaysPeriod = timeSpan.indexOf('.') > -1 && timeSpan.indexOf('.') < timeSpan.indexOf(':');

  const [dayPart, timePart] = isDaysPeriod ? timeSpan.split(/\.(.+)/) : ['0', timeSpan];

  const [hours = '0', minutes = '0', secondsWithMs = '0'] = timePart.split(':');
  const [seconds = '0', milliseconds = '0'] = secondsWithMs.includes('.') ? secondsWithMs.split('.') : [secondsWithMs, '0'];

  return {
    days: parseInt(dayPart, 10) || 0,
    hours: parseInt(hours, 10) || 0,
    minutes: parseInt(minutes, 10) || 0,
    seconds: parseInt(seconds, 10) || 0,
    milliseconds: parseInt(milliseconds.slice(0, 3), 10) || 0,
  };
};

String.prototype.toTimeSpan = function (): TimeSpan {
    return new TimeSpan(this.toTimeSpanType());
};

String.prototype.getLastPart = function (separator: string): string {
  let input = new String(this);

  let parts = input.split(separator);

  return parts[parts.length - 1];
};
